import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  standalone: false,
  selector: 'irembogov-tooltip-field-wrapper',
  templateUrl: './tooltip-field-wrapper.component.html',
  styleUrls: ['./tooltip-field-wrapper.component.scss'],
})
export class TooltipFieldWrapperComponent
  extends FieldWrapper
  implements OnInit
{
  @Input() tooltip?: string;
  @Input() tooltipPlacementInput?: string;

  private tooltipPlacementOptions: string[] = [
    'auto',
    'top',
    'top-start',
    'top-left',
    'top-end',
    'top-right',
    'bottom',
    'bottom-start',
    'bottom-left',
    'bottom-end',
    'bottom-right',
    'start',
    'left',
    'start-top',
    'left-top',
    'start-bottom',
    'left-bottom',
    'end',
    'right',
    'end-top',
    'right-top',
    'end-bottom',
    'right-bottom',
  ];

  tooltipPlacement = 'auto';
  constructor(private elRef: ElementRef, private renderer: Renderer2) {
    super();
  }

  ngOnInit() {
    if (this.resolvedTooltip) {
      this.setLabelClass();
    }

    this.tooltipPlacement = this.resolvedTooltipPlacement;
  }

  get resolvedTooltip(): string | undefined {
    return this.field?.props?.['tooltip'] ?? this.tooltip;
  }

  get resolvedTooltipPlacement(): string {
    const placement =
      this.field?.props?.['tooltipPlacement'] ?? this.tooltipPlacementInput;
    return this.tooltipPlacementOptions.includes(placement)
      ? placement
      : 'auto';
  }

  setLabelClass(): void {
    const formLabelElement = this.elRef.nativeElement.closest(
      'formly-wrapper-form-field'
    );
    if (formLabelElement) {
      this.renderer.setAttribute(
        formLabelElement,
        'class',
        'form-label-with-hint'
      );
    }
  }
}
